// extracted by mini-css-extract-plugin
module.exports = {"row":"PreferenceSettingsToggles_row__ZKxQT"};